import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

export default function UniversityMyEvents() {
  const { token, user } = useAuth();
  const [events, setEvents] = useState([]);
  const [editEventId, setEditEventId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetch('https://techservicemarket-backend.onrender.com/api/events', {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setEvents(data))
      .catch(err => console.error('Fetch error:', err));
  }, [token]);

  const handleEditClick = (event) => {
    setEditEventId(event._id);
    setEditForm({
      title: event.title,
      description: event.description,
      eventDate: event.eventDate,
      location: event.location,
      tags: event.tags.join(', ')
    });
  };

  const handleEditChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const submitEdit = async (id) => {
    try {
      const res = await fetch(`https://techservicemarket-backend.onrender.com/api/events/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          ...editForm,
          tags: editForm.tags.split(',').map(t => t.trim())
        })
      });
      if (!res.ok) throw new Error('Failed to update event.');
      const updated = await res.json();
      setEvents(events.map(ev => ev._id === id ? updated : ev));
      setEditEventId(null);
      setMessage('Event updated.');
    } catch (err) {
      setMessage(err.message);
    }
  };

  const deleteEvent = async (id) => {
    try {
      const res = await fetch(`https://techservicemarket-backend.onrender.com/api/events/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Failed to delete event.');
      setEvents(events.filter(ev => ev._id !== id));
      setConfirmDelete(null);
      setMessage('Event deleted.');
    } catch (err) {
      setMessage(err.message);
    }
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem' }}>
      <h2 style={{ textAlign: 'center', color: '#1e40af', fontSize: '2rem', marginBottom: '2rem' }}>
        My Events (University Partner)
      </h2>
      {message && <p style={{ color: '#047857', textAlign: 'center' }}>{message}</p>}

      {events.filter(ev => ev.author?._id === user?.id).length === 0 ? (
        <p style={{ textAlign: 'center' }}>You have not created any events yet.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {events.filter(ev => ev.author?._id === user?.id).map(ev => (
            <div key={ev._id}
              style={{
                backgroundColor: '#f9fafb',
                padding: '1.5rem',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}
            >
              {editEventId === ev._id ? (
                <>
                  <input name="title" value={editForm.title} onChange={handleEditChange} />
                  <input name="description" value={editForm.description} onChange={handleEditChange} />
                  <input name="eventDate" type="datetime-local" value={editForm.eventDate.slice(0, 16)} onChange={handleEditChange} />
                  <input name="location" value={editForm.location} onChange={handleEditChange} />
                  <input name="tags" value={editForm.tags} onChange={handleEditChange} />
                  <div style={{ marginTop: '10px' }}>
                    <button onClick={() => submitEdit(ev._id)} style={buttonStyle}>Save</button>
                    <button onClick={() => setEditEventId(null)} style={cancelButton}>Cancel</button>
                  </div>
                </>
              ) : (
                <>
                  <h3 style={{ marginBottom: '0.5rem', color: '#111827' }}>{ev.title}</h3>
                  <p><strong>Date:</strong> {new Date(ev.eventDate).toLocaleString()}</p>
                  <p><strong>Location:</strong> {ev.location}</p>
                  <p><strong>RSVPs:</strong> {ev.attendanceCount}</p>
                  <p style={{ marginTop: '0.5rem', fontSize: '0.9rem', color: '#6b7280' }}>
                    Created by: {ev.author?.username} ({ev.author?.role})
                  </p>
                  <div style={{ marginTop: '10px' }}>
                    <button onClick={() => handleEditClick(ev)} style={buttonStyle}>Edit</button>
                    <button onClick={() => setConfirmDelete(ev._id)} style={deleteButton}>Delete</button>
                  </div>
                </>
              )}

              {confirmDelete === ev._id && (
                <div style={{ marginTop: '1rem', padding: '1rem', backgroundColor: '#fff7ed', borderRadius: '8px' }}>
                  <p>Are you sure you want to delete this event?</p>
                  <button onClick={() => deleteEvent(ev._id)} style={deleteButton}>Yes, Delete</button>
                  <button onClick={() => setConfirmDelete(null)} style={cancelButton}>Cancel</button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const buttonStyle = {
  backgroundColor: '#1e40af',
  color: 'white',
  padding: '0.5rem 1rem',
  marginRight: '0.5rem',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer'
};

const deleteButton = {
  ...buttonStyle,
  backgroundColor: '#dc2626'
};

const cancelButton = {
  ...buttonStyle,
  backgroundColor: '#6b7280'
};
